/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:18]
Permissions to update outside the main branch: [false]
*/

//TODO по хорошему расковырять что там внутри и уточнить типы
type Widget = {
    api: any;
    emitter: any;
};

export function AssertIsWidget(e: any): asserts e is Widget {
    if (!e || !('api' in e) || !('emitter' in e)) {
        throw new Error(`Node expected`);
    }
}

export function CallToClient(clientId: string | number | undefined) {
    const widget = document.querySelector('w-widget');
    AssertIsWidget(widget);
    widget.api.communication('' + clientId + '', 1);
}

export function SetWidgetLanguage(culture: string) {
    const widget = document.querySelector('w-widget');

    if (widget) {
        AssertIsWidget(widget);
        widget.api.setLocale(culture);
    }
}
